export default "__VITE_ASSET__DEkc7gc5__"